<template>
  <div class="content_box">
    <div id="menuManage">
      <div class="leftTree">
        <el-tree
          node-key="id"
          ref="tree"
          :data="menuTree"
          :props="defaultProps"
          @node-click="handleNodeClick"
          default-expand-all
          v-loading="menuTreeLoading"
        ></el-tree>
      </div>
      <div class="rightCon contentPadding42" id="ManageTable">
        <div class="headTitle">
          <img src="@/assets/imgs/icon/icon_headIcon.png" alt />
          行业代码
        </div>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="行业代码" style="margin-right: 30px">
            <el-input
              v-model="searchObj.code"
              placeholder="请输入代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="行业名称" style="margin-right: 30px">
            <el-input
              v-model="searchObj.name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSearch"
              class="bg5584FF formBotton"
              style="margin-left: 40px"
              >查询</el-button
            >
            <el-button type="info" @click="onReset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <hr />
        <el-button type="primary" size="small" class="bg5584FF" @click="addNew">
          <i class="el-icon-plus"></i> 新增行业
        </el-button>
        <div style="height: 20px"></div>
        <el-table
          border
          v-loading="loading"
          :data="menuList"
          style="width: 100%"
          stripe
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        >
          <el-table-column align="center" prop="code" label="行业代码">
          </el-table-column>
          <el-table-column align="center" prop="name" label="行业名称">
            <template slot-scope="scope"
              ><a
                style="color: #5582f7; cursor: pointer"
                @click="toShow(scope.row)"
                >{{ scope.row.name }}</a
              ></template
            >
          </el-table-column>
          <!-- <el-table-column align="center" prop="parent_code" label="上级行业">
          <template slot-scope="scope">{{
            getParentName(scope.row.parent_code, scope.row)
          }}</template>
        </el-table-column> -->
          <el-table-column
            align="center"
            prop="des"
            label="备注"
          ></el-table-column>
          <el-table-column align="center" prop="isSelect" label="是否可选择">
            <template slot-scope="scope">{{
              scope.row.isSelect == "0" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="editMenu(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                class="MR18 bg5584FF"
                type="primary"
                @click="deleteMenu(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pageBox">
          <!-- <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total,  prev, pager, next"
            :total="totalNum"
          >
          </el-pagination> -->
        </div>
      </div>
      <!-- 删除弹框 -->
      <el-dialog title="提示" :visible.sync="showDeleteWindow" class="delete">
        <p>确认要删除行业"{{ deleteName }}"？</p>
        <div class="btnBox MT40">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureDelete"
            >确定</el-button
          >
          <el-button type="normal" size="mini" @click="showDeleteWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看弹框 -->
      <el-dialog
        title="查看行业"
        :visible.sync="showWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="editForm"
          :model="showObj"
          label-width="130px"
          size="small"
        >
          <el-form-item label="代码：">
            <el-input disabled v-model="showObj.code"></el-input>
          </el-form-item>
          <el-form-item label="名称：">
            <el-input disabled v-model="showObj.name"></el-input>
          </el-form-item>
          <!-- <el-form-item label="上级行业：" v-if="showObj.parent_code !== '-1'">
          <el-input disabled v-model="showObj.parent_name"></el-input>
        </el-form-item> -->
          <el-form-item label="备注：">
            <el-input disabled v-model="showObj.des"></el-input>
          </el-form-item>
          <el-form-item label="是否可选：">
            <el-input
              disabled
              :value="showObj.is_select === '1' ? '否' : '是'"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 编辑弹框 -->
      <el-dialog
        title="编辑行业"
        :visible.sync="showEditWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="editForm"
          :model="editObj"
          label-width="130px"
          size="small"
          v-loading="editLoading"
          :rules="rules"
        >
          <el-form-item label="代码：" prop="code">
            <el-input disabled v-model="editObj.code"></el-input>
          </el-form-item>
          <el-form-item label="名称：" prop="name">
            <el-input v-model="editObj.name"></el-input>
          </el-form-item>
          <!-- <el-form-item
          label="上级行业："
          v-if="editObj.parent_code !== '0'"
          prop="parentName"
        >
          <el-input disabled v-model="editObj.parent_name"></el-input>
        </el-form-item> -->
          <el-form-item label="备注：">
            <el-input v-model="editObj.des"></el-input>
          </el-form-item>
          <el-form-item label="是否可选：" prop="isSelect">
            <el-radio-group v-model="editObj.isSelect">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="btnBox">
          <el-button
            type="primary"
            size="mini"
            class="bg5584FF"
            @click="sureEdit"
            >提交</el-button
          >
          <el-button type="normal" size="mini" @click="showEditWindow = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增提升 -->
      <el-dialog title="提示" :visible.sync="showAddFalse" class="delete">
        <p>请选中左侧第一、二级行业名称后点击，第三级以下无法新增行业节点</p>
        <div class="btnBox MT40">
          <el-button type="normal" size="mini" @click="showAddFalse = false"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 新增弹框 -->
      <el-dialog
        title="新增行业"
        :visible.sync="showAddWindow"
        class="dialog770 titleChange"
        width="470px"
      >
        <el-form
          ref="addForm"
          :model="addObj"
          label-width="130px"
          size="small"
          v-loading="addLoading"
          :rules="rules"
        >
          <el-form-item label="代码：" prop="code">
            <el-input v-model="addObj.code"></el-input>
          </el-form-item>
          <el-form-item label="名称：" prop="name">
            <el-input v-model="addObj.name"></el-input>
          </el-form-item>
          <!-- <el-form-item
          label="上级行业："
          prop="parent_name"
          v-if="addObj.parent_code !== '-1'"
        >
          <el-input disabled v-model="addObj.parent_name"></el-input>
        </el-form-item> -->
          <el-form-item label="备注：">
            <el-input v-model="addObj.des"></el-input>
          </el-form-item>
          <el-form-item label="是否可选：" prop="isSelect">
            <el-radio-group v-model="addObj.isSelect">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="btnBox">
            <el-button
              type="primary"
              size="mini"
              class="bg5584FF"
              @click="sureAdd"
              >新增</el-button
            >
            <el-button type="normal" size="mini" @click="showAddWindow = false"
              >取消</el-button
            >
          </div>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    var checkBH = (rule, value, callback) => {
      if (value) {
        let rgx = /^[a-zA-Z0-9]{1,8}$/;
        if (value.match(rgx) == null) {
          return callback(new Error("请输入数字或字母"));
        } else {
          callback();
        }
      } else {
        return callback(new Error("不能为空"));
      }
    };
    return {
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      searchObj: {
        name: "",
        code: "",
      },
      menuList: [],
      treeData: [],
      editObj: {},
      pageSize: 20,
      addObj: {},
      showObj: {},
      deleteId: "",
      currentPage: 1,
      showDeleteWindow: false,
      showWindow: false,
      showEditWindow: false,
      showAddWindow: false,
      showAddFalse: false,
      loading: false,
      addLoading: false,
      menuTreeLoading: false,
      editLoading: false,
      totalNum: 0,
      pageObj: {},
      deleteName: "",
      nodeDisabled: "",
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, validator: checkBH, trigger: "change" }],
        parent_name: [
          { required: true, message: "请选择上级名称", trigger: "change" },
        ],
        is_select: [
          { required: true, message: "请选择是否可选", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    onSearch() {
      this.getMenuList2();
    },
    onReset() {
      this.searchObj = {
        name: "",
        parent_code: -1,
        code: "",
      };
      this.getMenuList(1);
    },
    addNew() {
      console.log(this.addObj.parent_code);
      if (this.addObj.parent_code && this.nodeDisabled == "1") {
        this.addObj = {
          name: "",
          code: "",
          des: "",
          isDelete: "0",
          isSelect: "0",
          parentCode: this.addObj.parent_code,
          parent_name: this.addObj.parent_name,
        };

        this.showAddWindow = true;
      } else {
        this.showAddFalse = true;
      }
    },
    sureAdd() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          console.log(this.addObj);
          this.$axios
            .post("business/industry/insertBaseIndustry", {
              code: this.addObj.code,
              des: this.addObj.des,
              name: this.addObj.name,
              parentCode: this.addObj.parentCode,
              isDelete: "0",
              isSelect: "0",
            })
            .then(() => {
              Message.success("新增成功");
              this.addLoading = false;
              this.showAddWindow = false;
              this.getMenuList(1);
              this.getMenuTree();
            })
            .catch((res) => {
              this.addLoading = false;
              console.log("新增失败", res);
            });
        } else {
          Message.error("请完善表单信息");
          return false;
        }
      });
    },
    editMenu(row) {
      console.log(row);
      this.editObj = JSON.parse(JSON.stringify(row));
      this.showEditWindow = true;
    },
    toShow(row) {
      this.showObj = JSON.parse(JSON.stringify(row));
      this.showWindow = true;
    },
    sureEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          console.log("编辑对象", this.editObj);
          this.$axios
            .put("/business/industry/updateBaseIndustry", {
              id: this.editObj.id,
              code: this.editObj.code,
              des: this.editObj.des,
              name: this.editObj.name,
              parentCode: this.editObj.parentCode,
              isSelect: this.editObj.isSelect,
            })
            .then((res) => {
              Message.success("修改成功");
              this.editLoading = false;
              this.showEditWindow = false;
              this.getMenuList();
              this.getMenuTree();
              console.log("编辑成功", res);
            })
            .catch((res) => {
              this.editLoading = false;
              console.log("编辑错误", res);
            });
        } else {
          Message.error("请完善表单信息");
        }
      });
    },
    deleteMenu(row) {
      this.deleteId = row.id;
      this.deleteName = row.name;
      this.showDeleteWindow = true;
    },
    sureDelete() {
      console.log(this.deleteId);
      let id = this.deleteId;
      this.$axios
        .delete("/business/industry/deleteBaseIndustry?id=" + id)
        .then((res) => {
          console.log(res);
          Message.success("删除成功");
          this.showDeleteWindow = false;
          this.getMenuList();
          this.getMenuTree();
        })
        .catch((res) => {
          console.log("删除失败", res);
          this.showDeleteWindow = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMenuList(1);
    },
    handleCurrentChange(current) {
      this.getMenuList(current);
    },
    handleNodeClick(obj, node) {
      console.log(obj, node);
      console.log(node.childNodes);
      if (node.childNodes.length == 0) {
        this.nodeDisabled = "0";
      } else {
        this.nodeDisabled = "1";
      }
      this.addObj.parent_code = obj.code;
      this.addObj.parent_name = obj.name;
      // this.searchObj["parent_code"] = obj.value;
      // this.getMenuList();
      this.getMenuList1(obj.code);
    },
    getNoteData(node, data) {
      data.unshift(node.data.value);
      if (node.parent !== null) {
        this.getNoteData(node.parent, data);
      }
    },
    //获取行业树
    getMenuTree() {
      this.menuTreeLoading = true;
      this.$axios
        .get("/business/industry/selectIndustryTree")
        .then((res) => {
          console.log("行业树结果", res.data);
          res.data.data.map((item) => {
            if (item.children.length > 0) {
              item.children.map((item_children) => {
                if (item_children.children.length > 0) {
                  item_children.disabled = true;
                }
              });
            }
          });

          this.menuTree = res.data.data;
          console.log("+++++++++++++++++", this.menuTree);
          this.menuTreeLoading = false;
        })
        .catch((res) => {
          console.log("行业树获取失败", res);
          this.menuTreeLoading = false;
        });
    },
    toTree(treeData) {
      const treeArr = [];
      for (let i = 0; i < treeData.length; i++) {
        const node = treeData[i];
        const newNode = {
          code: node.code,
          value: node.code,
          name: node.name,
          label: node.name,
          children: node.children,
        };
        treeArr.push(newNode);
      }
      return treeArr;
    },
    //获取表格信息
    getMenuList(page) {
      this.loading = true;
      const param = Object.assign(
        {
          page: page ? page : 1,
          size: this.pageSize,
        },
        this.searchObj
      );
      this.$axios
        .post("/business/dm/hy/page", param)
        .then((res) => {
          this.loading = false;
          this.menuList = res.data;
          this.totalNum = res.total;
          console.log("行业列表结果", res);
        })
        .catch((res) => {
          this.loading = false;
          console.log("行业列表错误信息", res);
        });
    },
    getMenuList1(code) {
      this.loading = true;
      this.$axios
        .get("/business/industry/selectIndustryTree?code=" + code)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.menuList = res.data.data;
          console.log(this.menuList);
          // this.totalNum = res.total;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    getMenuList2() {
      console.log(this.searchObj);
      let pram = this.searchObj;
      this.loading = true;
      this.$axios
        .get(
          `/business/industry/selectByCodeAndName?code=${this.searchObj.code}&name=${this.searchObj.name}`
        )
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.menuList = res.data.data;
          // this.totalNum = res.total;
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    getParentName(code, row) {
      for (let i = 0; i < this.treeData.length; i++) {
        console.log("0000000000000000", row);
        if (this.treeData[i].code === code) {
          row["parent_name"] = this.treeData[i].name;
          return this.treeData[i].name;
        }
      }
    },
  },
  created() {
    this.getMenuTree();
    this.getMenuList1(0);
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
#menuManage {
  box-shadow: 0px 0px 50px #ccc;
  height: calc(90vh - 76px);
  display: flex;
  .leftTree {
    width: 260px;
    background-color: rgba(247, 248, 250, 1);
    box-sizing: border-box;
    padding: 20px 0px;
    height: 100%;
    overflow-y: auto;
  }
  .rightCon {
    width: calc(100% - 260px);
    height: 100%;
    overflow-y: auto;
    border-left: 1px solid rgb(220, 223, 230);
  }
  .el-cascader {
    width: 100%;
  }
}
#menuManage /deep/ .el-tree-node__children {
  .el-tree-node__label {
    padding: 2px 4px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  }

  .el-tree-node.is-current {
    background: rgba(247, 248, 250, 1);
    & > div:first-child .el-tree-node__label {
      background-color: #5584ff;
      color: #fff;
      box-shadow: 0px 2px 4px 0px #5584ff;
    }
  }
}
#menuManage .el-tree {
  background: rgba(247, 248, 250, 1);
}
.headTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(68, 68, 68, 1);
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  img {
    margin-right: 24px;
    padding-left: 2px;
  }
}
hr {
  border-color: rgba(155, 155, 155, 0.2);
  margin: 10px 0 20px;
}
</style>